
export default (function (ref) {
  return ref ? ref.ownerDocument.defaultView : window;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-beautiful-dnd/esm/view/get-window-from-ref.js
// module id = 130
// module chunks = 0